import { createReducer, on } from '@ngrx/store';
import { Contact, LoadingStatus, UserProfile } from '@qvs/core';
import * as fromUserActions from './user.actions';
import { authenticateByContractNumber, cancelAuthentication } from '@qvs/core/auth';

export const userFeatureKey = 'user';

export interface State {
  userProfile: UserProfile;
  sessionActive: boolean;
  loadingStatus: LoadingStatus;
  crm: {
    currentClient: Contact;
  };
}

export const initialState: State = {
  userProfile: {
    role: null,
    person: null,
    capabilities: {},
    contacts: []
  },
  sessionActive: false,
  loadingStatus: LoadingStatus.IDLE,
  crm: {
    currentClient: null
  }
};

export const reducer = createReducer(
  initialState,
  on(authenticateByContractNumber, () => ({ ...initialState })),
  on(cancelAuthentication, () => ({ ...initialState })),
  on(fromUserActions.loadUserProfile, (state) => ({
    ...state,
    userProfile: initialState.userProfile,
    loadingStatus: LoadingStatus.LOADING
  })),
  on(fromUserActions.loadUserProfileSuccess, (state, { userProfile }) => ({
    ...state,
    userProfile,
    loadingStatus: LoadingStatus.SUCCEEDED
  })),
  on(fromUserActions.checkUserSessionIsActiveSuccess, (state) => ({
    ...state,
    sessionActive: true
  })),
  on(fromUserActions.checkUserSessionIsActiveFailure, (state) => ({
    ...state,
    sessionActive: false
  })),
  on(fromUserActions.loadUserProfileFailure, (state) => ({
    ...state,
    loadingStatus: LoadingStatus.FAILED
  })),
  on(fromUserActions.updateCrmSuccess, (state, { userProfile }) => ({
    ...state,
    loadingStatus: LoadingStatus.SUCCEEDED,
    userProfile: { ...userProfile }
  })),
  on(fromUserActions.setCurrentClient, (state, { client }) => ({
    ...state,
    crm: { ...state.crm, currentClient: client }
  })),
  on(fromUserActions.clearCurrentClient, (state) => ({
    ...state,
    crm: { ...state.crm, currentClient: null }
  }))
);
